import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GalleryPage from './pages/GalleryPage';
import OurWorkPage from './pages/OurWorkPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import Header from './components/Header';
import Footer from './components/Footer';
import { artworks, projects, categories, branches } from './data/galleryData';
import { initializeImageProtection, removeImageProtection } from './utils/imageProtection';

// Site configuration
const siteSettings = {
  whatsappLink: 'https://wa.me/94773643253',
  instagramLink: 'https://www.instagram.com/kolinskyartgallery?igsh=Njh6cG85aXVrbmxt',
  facebookLink: 'https://www.facebook.com/share/1FV8da7PZu/?mibextid=wwXIfr', 
  emailAddress: 'kolinskyartgallery@gmail.com'
};

const galleryInfo = {
  logoUrl: 'https://kolinskyartstorage.blob.core.windows.net/$web/logo.png',
  addressUnawatuna: 'Unawatuna, Sri Lanka',
  addressMirissa: 'Mirissa, Sri Lanka',
  branches: branches
};

// Main App component with routing
function App() {
  useEffect(() => {
    initializeImageProtection();
    return () => {
      removeImageProtection();
    };
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header galleryInfo={galleryInfo} siteSettings={siteSettings} />
        
        <main className="flex-grow">
          <Routes>
            <Route 
              path="/" 
              element={<HomePage artworks={artworks} galleryInfo={galleryInfo} siteSettings={siteSettings} />} 
            />
            <Route 
              path="/gallery" 
              element={<GalleryPage artworks={artworks} categories={categories} siteSettings={siteSettings} />} 
            />
            <Route 
              path="/our-work" 
              element={<OurWorkPage siteSettings={siteSettings} projects={projects} isLoading={false} />} 
            />
            <Route path="/about" element={<AboutPage />} />
            <Route 
              path="/contact" 
              element={<ContactPage galleryInfo={galleryInfo} siteSettings={siteSettings} branches={branches} />} 
            />
          </Routes>
        </main>

        <Footer galleryInfo={galleryInfo} siteSettings={siteSettings} branches={branches} />
      </div>
    </Router>
  );
}

export default App;